module.exports = __webpack_public_path__ + "media/images/options-d458bb8d.svg";